import React from "react";

const Dropdown = ({
  label,
  labelFor,
  options,
  value = "",
  setVal = (v) => {},
  disabled,
}) => {
  const handleSelectChange = (event) => {
    setVal(event.target.value);
  };

  return (
    <div style={{ position: "relative" }}>
      <div style={{ position: "relative", zIndex: "2" }}>
        {label && <label htmlFor={labelFor}>{label}</label>}
        <select
          className="form-select form-select-lg"
          aria-label=".form-select-lg"
          id={labelFor}
          value={value}
          onChange={handleSelectChange}
          style={{
            fontWeight: value ? "700" : "300",
            color: value ? "black" : "#A7A7A7",
          }}
          disabled={disabled}
        >
          <option value="" disabled>
            Select {label} (Option)
          </option>
          {options?.map((option, index) => (
            <option
              key={index}
              value={option.value ? option.value : option.label}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <img
        src="./img/icon/dropdown-icon.png"
        alt=""
        className="dropdown-icon-style"
      />
    </div>
  );
};

export default Dropdown;
